import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {useFormik} from 'formik';
import {useAuth} from '../../context/AuthContext';
import server from '../../global/server';
import Typography from '@mui/material/Typography';
import {useApp} from '../../context/AppContext';
import LoadingButton from '@mui/lab/LoadingButton';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import {useNavigate, useParams, useSearchParams} from 'react-router-dom';
import {useSnackbar} from 'notistack';
import * as Yup from 'yup';
import useHandleErrors from '../../hooks/useHandleErrors';
import {Avatar, Container, Stack} from '@mui/material';
import InputFile from '../../components/InputFile';
import { noAutoFormat } from "../../global/helpers";

export default props => {
    const [search] = useSearchParams();
    const {verifySession, user} = useAuth();
    const {isOffline} = useApp();
    const [hasError, setError] = useState();
    useHandleErrors(hasError);

    const navigation = useNavigate();

    const RegisterSchema = Yup.object().shape({
        password: Yup.string().min(6, 'Mínimo de 6 caracteres').required('Campo obrigatório'),
        repeat_password: Yup.string()
            .oneOf([Yup.ref('password'), null], 'As senhas não conferem')
            .required('Campo obrigatório'),
    });

    const {enqueueSnackbar} = useSnackbar();
    const {
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleReset,
        handleSubmit,
        isSubmitting,
        setFieldValue,
        setValues,
    } = useFormik({
        initialValues: {password: '', repeat_password: ''},
        validationSchema: RegisterSchema,
        onSubmit: async (values, {setSubmitting}) => {
            try {
                setSubmitting(true);

                const {data} = await server.put('account', values);
                enqueueSnackbar('Dados alterados.');
                verifySession();
                setSubmitting(false);
            } catch (error) {
                setSubmitting(false);

                setError(error);
            }
        },
    });

    useEffect(() => {
        if (user) {
            setValues(
                {
                    email: user.email,
                    name: user.name,
                },
                true,
            );
        }
    }, [user]);

    return (
        <Container maxWidth="xs" sx={{my: 4}}>
            <form onSubmit={handleSubmit}>
                <Grid container direction="column" gap={2}>
                    <Grid item xs={12}>
                        <Title>
                            <Typography variant="h6">Mudar sua senha</Typography>
                        </Title>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            required
                            label="Senha"
                            type="password"
                            name="password"
                            inputProps={noAutoFormat}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.password}
                            disabled={isOffline}
                            error={Boolean(errors.password)}
                            helperText={errors.password}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            label="Repita a Senha"
                            type="password"
                            name="repeat_password"
                            inputProps={noAutoFormat}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.repeat_password}
                            error={Boolean(errors.repeat_password)}
                            helperText={errors.repeat_password}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <LoadingButton
                            type="submit"
                            fullWidth
                            loading={isSubmitting}
                            variant="contained"
                            disabled={Boolean(Object.keys(errors).length) || isSubmitting}>
                            Salvar dados
                        </LoadingButton>
                    </Grid>
                </Grid>
            </form>
        </Container>
    );
};

const PanelAuth = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #eee;
`;

const BoxAuth = styled(Grid)`
    border: 1px solid #ccc;
    border-radius: 0.7rem;
    padding: 1.5rem;
    width: 350px;
    background: white;
`;

const Title = styled.div`
    text-align: center;
    margin-bottom: 20px;
`;

const BoxAuthContainer = styled.div`
    padding: 1px;
`;
